"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var whiteLabelConfigExtractor = function (featureName) { return function (resolverFactory) { return resolverFactory.getConfigLookupResolver().getBy(featureName); }; };
exports.default = whiteLabelConfigExtractor;
